import { render } from "./EventList.vue?vue&type=template&id=d17ce20a&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=d17ce20a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d17ce20a"

export default script